const apiUrl = 'http://127.0.0.1:8000';
const douzeroDemoUrl = 'http://127.0.0.1:5000';

export { apiUrl, douzeroDemoUrl };
